/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Tournament_Decklist_Api_DescriptionInputs */



/**
* | output |
* | --- |
* | "Push entrant decklists from your registration system into a tournament's deck check: API keys, the payload, claim links, and limits." |
*
* @param {Help_Article_Tournament_Decklist_Api_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_tournament_decklist_api_description = /** @type {((inputs?: Help_Article_Tournament_Decklist_Api_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Tournament_Decklist_Api_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schick Decklisten der Teilnehmer aus deinem Anmeldesystem in den Deck-Check eines Turniers: API-Schlüssel, Payload, Claim-Links und Limits.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyez les decklists des inscrits depuis votre système d'inscription vers le contrôle de deck d'un tournoi : clés d'API, payload, liens de réclamation et limites.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("把报名系统中的参赛卡组表推送到赛事的卡组检查：API 密钥、请求内容、认领链接和各项限制。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("把報名系統中的參賽牌組清單推送到賽事的牌堆檢查：API 金鑰、酬載、認領連結與限制。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("등록 시스템에서 참가자 덱 목록을 대회 덱 점검으로 보내는 방법입니다. API 키, 페이로드, 클레임 링크, 제한을 다룹니다.")
	return /** @type {LocalizedString} */ ("Push entrant decklists from your registration system into a tournament's deck check: API keys, the payload, claim links, and limits.")
});